module.exports = __webpack_public_path__ + "img/1080_08.f0703953.jpg";